import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChatBubbleLeftRightIcon, XMarkIcon } from '@heroicons/react/24/outline';
import {
  selectWidgetView,
  selectUnreadCount,
  selectIsConnected,
  selectIsAuthenticated,
  selectError,
  setWidgetOpen,
  closeActiveConversation,
  clearError
} from '../../store/slices/chatSlice';
import ConversationList from './ConversationList';
import ChatThread from './ChatThread';
import './ChatWidget.css';

const ChatWidget = () => {
  const dispatch = useDispatch();
  const widgetView = useSelector(selectWidgetView);
  const unreadCount = useSelector(selectUnreadCount);
  const isConnected = useSelector(selectIsConnected);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const error = useSelector(selectError);

  const handleCloseWidget = () => {
    dispatch(setWidgetOpen(false));
    dispatch(closeActiveConversation());
    dispatch(clearError());
  };

  const getConnectionStatus = () => {
    if (!isConnected) return 'Connecting...';
    if (!isAuthenticated) return 'Authenticating...';
    return 'Connected';
  };

  const getConnectionStatusColor = () => {
    if (!isConnected) return 'text-yellow-500';
    if (!isAuthenticated) return 'text-yellow-500';
    return 'text-green-500';
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-25 z-40"
        onClick={handleCloseWidget}
      />
      
      {/* Chat Widget Modal */}
      <div className="chat-widget-modal">
        {/* Header */}
        <div className="chat-widget-header">
          <div className="flex items-center space-x-2">
            <ChatBubbleLeftRightIcon className="h-5 w-5" />
            <h3 className="text-sm font-medium">Client Messages</h3>
            {unreadCount > 0 && (
              <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {unreadCount}
              </span>
            )}
          </div>
          <button
            onClick={handleCloseWidget}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        {/* Connection Status */}
        <div className="px-4 py-2 bg-gray-50 border-b border-gray-200">
          <div className="flex items-center justify-between text-xs">
            <span className={`${getConnectionStatusColor()}`}>
              ● {getConnectionStatus()}
            </span>
            {error && (
              <span className="text-red-500 truncate max-w-48" title={error}>
                {error}
              </span>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="chat-widget-content">
          {widgetView === 'conversations' && <ConversationList />}
          {widgetView === 'chat' && <ChatThread />}
        </div>
      </div>
    </>
  );
};

export default ChatWidget;